import { useFormikContext } from "formik";
import { HoopsApi, useAPIAction } from "melco-shared-logic";
import { useState } from "react";

export const useRevertHoops = (id: string, refetch: any) => {
  let dateOfLastRevert = new Date().getTime();
  const [revertKey, setRevertKey] = useState(dateOfLastRevert);
  const { resetForm } = useFormikContext();
  return [
    ...useAPIAction(
      HoopsApi,
      async (api) => {
        let res = await api.hoopsRevert({
          id: id,
        });
        // return res;
        return {
          successMessages: [
            {
              message: "Hoop successfully reverted",
            },
          ],
          data: res,
        };
      },
      {
        translationPrefix: "managehoops.actions.revert",
        onSuccess: async () => {
          const response = await refetch();

          resetForm({
            values: response?.data ?? {},
          });
        },
      }
    ),
    revertKey,
  ] as const;
};
